import { Typography, Card, Box, Divider, useMediaQuery, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecordContext } from "react-admin";
import AnimatedBlock from "../../../components/Common/AnimatedBlock";
import InfoRow from "../../../components/Common/InfoRow";

// A raw value as read (bypassed → Bypassed, lowRisk → Low risk, legal_person → Legal person).
export const readable = (value?: string) => {
  const text = String(value || "").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/_/g, " ").trim();
  return text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : "—";
};

// A Travel rule party as one value: its name, then its type (Self, VASP...).
const party = (name?: string, type?: string) => (name ? [name, type && `(${readable(type)})`].filter(Boolean).join(" ") : readable(type));

function InfoKytTravelRuleTab() {
  const { t }: { t: any } = useTranslation();
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down("sm"));
  const record = useRecordContext();

  if (!record) return null;

  return (
    <Box>
      {!isMobile && (
        <Box pb={2}>
          <Typography variant="h6">
            {t("KYT & Travel rule")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t("Risk screening and Travel rule data for this transfer.")}
          </Typography>
        </Box>
      )}

      <AnimatedBlock>
        <Card>
          <Box px={2} py={1}>
            <InfoRow label={t("KYT rating")}>{readable(record.kytRating)}</InfoRow>
          </Box>
          <Divider />
          <Box px={2} pt={2}>
            <Typography variant="overline" color="text.secondary">
              {t("Travel rule")}
            </Typography>
          </Box>
          <Box px={2} pb={1}>
            <InfoRow label={t("Owner")}>{party(record.travelRuleOwner, record.travelRuleOwnerType)}</InfoRow>
            <InfoRow label={t("Host")}>{party(record.travelRuleHost, record.travelRuleHostType)}</InfoRow>
          </Box>
        </Card>
      </AnimatedBlock>
    </Box>
  );
}

export default InfoKytTravelRuleTab;
